
const key = async (keyBytes) => {
    return await crypto.subtle.importKey(
        'raw',
        keyBytes,
        { name: 'AES-CBC' },
        false,
        ['decrypt']
    );
}

const process = async (k, i, data) => {
    return await crypto.subtle.decrypt(
        { name: 'AES-CBC', iv: i },
        await key(k),
        data,
    )
}

export default process;
